export const Note = "Note/";
export const DeleteNote = Note + 'Delete';
export const SaveNote = Note + 'Save';
export const GetNoteById = Note + 'GetById';
export const SearchNotes = Note + 'Search';
export const GetUserList = Note + 'GetUserList';
export const GetInvalidUserList = Note + 'GetInvalidUserList';
export const SearchFeedback = Note + 'SearchFeedback';
export const SaveFeedback = Note + 'SaveFeedback';
export const DeleteFeedback = Note + 'DeleteFeedback';
export const SendNoteToResponsibleUser = Note + 'SendNoteToResponsibleUser';